import { View } from "@react-pdf/renderer";

import { styles } from "components/Resume/ResumePDF/styles";
import type { ResumeCustom } from "lib/redux/types";
import { ResumePDFDescription, TemplateThirteenLeftColumnSection } from "./common";

export const Custom = ({
  heading,
  custom,
  themeColor,
  enableMistakeHighlight = false,
}: {
  heading: string;
  custom: ResumeCustom;
  themeColor: string;
  enableMistakeHighlight?: boolean;
}) => {
  const { descriptions } = custom;

  return (
    <TemplateThirteenLeftColumnSection themeColor={themeColor} heading={heading}>
      <View style={{ ...styles.flexCol }}>
        <ResumePDFDescription items={descriptions} themeColor="black" enableMistakeHighlight={enableMistakeHighlight} />
      </View>
    </TemplateThirteenLeftColumnSection>
  );
};
